import { defineMessages } from 'react-intl';

const messages = defineMessages({
  completedLessonsInSection: {
    id: 'ViewQuiz.completedLessonsInSection',
    defaultMessage:
      '{completedLessons} completed lesson(s) of {totalLessons} total lesson(s) in the section',
    description: 'Tooltip label displayed on view quiz page',
  },
  backToTitle: {
    id: 'ViewQuiz.backToTitle',
    defaultMessage: 'Back to {name}',
    description: 'Tooltip title displayed on view quiz page',
  },
  timeLimit: {
    id: 'ViewQuiz.timeLimit',
    defaultMessage: 'Time limit:',
    description: 'Text displayed on view quiz page',
  },
  startQuizBtnLabel: {
    id: 'ViewQuiz.startQuizBtnLabel',
    defaultMessage: 'Start Quiz',
    description: 'Button label displayed on view quiz page',
  },
  startExamBtnLabel: {
    id: 'ViewQuiz.startExamBtnLabel',
    defaultMessage: 'Start Exam',
    description: 'Button label displayed on view quiz page',
  },
  resumeExamBtnLabel: {
    id: 'ViewQuiz.resumeExamBtnLabel',
    defaultMessage: 'Resume Exam',
    description: 'Button label displayed on view quiz page',
  },
  summaryTitle: {
    id: 'ViewQuiz.summaryTitle',
    defaultMessage: 'Summary',
    description: 'Text displayed on view quiz page',
  },
  questionsText: {
    id: 'ViewQuiz.questionsText',
    defaultMessage: 'questions',
    description: 'Text displayed on view quiz page',
  },
  completedText: {
    id: 'ViewQuiz.completedText',
    defaultMessage: 'completed',
    description: 'Text displayed on view quiz page',
  },
  questionsTitle: {
    id: 'ViewQuiz.questionsTitle',
    defaultMessage: 'Questions:',
    description: 'Text displayed on view quiz page',
  },
  ofText: {
    id: 'ViewQuiz.ofText',
    defaultMessage: 'of',
    description: 'Text displayed on view quiz page',
  },
  finishBtnLabel: {
    id: 'ViewQuiz.finishBtnLabel',
    defaultMessage: 'Finish',
    description: 'Button label displayed on view quiz page',
  },
  answeredText: {
    id: 'ViewQuiz.answeredText',
    defaultMessage: 'Answered',
    description: 'Text displayed on view quiz page',
  },
  correctText: {
    id: 'ViewQuiz.correctText',
    defaultMessage: 'Correct',
    description: 'Text displayed on view quiz page',
  },
  incorrectText: {
    id: 'ViewQuiz.incorrectText',
    defaultMessage: 'Incorrect',
    description: 'Text displayed on view quiz page',
  },
  reviewText: {
    id: 'ViewQuiz.reviewText',
    defaultMessage: 'Review',
    description: 'Text displayed on view quiz page',
  },
  reviewBtnLabel: {
    id: 'ViewQuiz.reviewBtnLabel',
    defaultMessage: 'Mark question for later review',
    description: 'Button label displayed on view quiz page',
  },
  questionText: {
    id: 'ViewQuiz.questionText',
    defaultMessage: 'Question',
    description: 'Text displayed on view quiz page',
  },
  goToBtnLabel: {
    id: 'ViewQuiz.goToBtnLabel',
    defaultMessage: 'Go to {name}',
    description: 'Button label displayed on view quiz page',
  },
  nextBtnLabel: {
    id: 'ViewQuiz.nextBtnLabel',
    defaultMessage: 'Next',
    description: 'Button label displayed on view quiz page',
  },
  showCertificateBtnLabel: {
    id: 'LessonDetails.showCertificateBtnLabel',
    defaultMessage: 'Show course certificate',
    description: 'Button shown when course is completed',
  },
  noQuestionsText: {
    id: 'ViewQuiz.noQuestionsText',
    defaultMessage: "Questions aren't added to quiz yet. Check back later.",
    description: 'Text shown when there are no questions in quiz',
  },
  examNameLabel: {
    id: 'ViewQuiz.examNameLabel',
    defaultMessage: 'Exam {name}',
    description: 'Exam label shown on view quiz page',
  },
  attemptsTitle: {
    id: 'ViewQuiz.attemptsTitle',
    defaultMessage: 'Attempts:',
    description: 'Title for users attempts shown on view quiz page',
  },
  dueDateTitle: {
    id: 'ViewQuiz.dueDateTitle',
    defaultMessage: 'Due date:',
    description: 'Title for exam due date shown on view quiz page',
  },
  lockExamMsg: {
    id: 'ViewQuiz.lockExamMsg',
    defaultMessage: 'Exam is locked. Contact your teacher for unlock exam.',
    description: 'Message about lock exam for user shown on view quiz page',
  },
  lockExamMsgProfessional: {
    id: 'ViewQuiz.lockExamMsgProfessional',
    defaultMessage: 'Exam is locked. Contact your teacher for unlock exam.',
    description:
      'Message about lock exam for user shown on view quiz page for professional organizations',
  },
  back: {
    id: 'ViewQuiz.back',
    defaultMessage: 'Back',
  },
  ended: {
    id: 'Viewquiz.ended',
    defaultMessage:
      'Exam end time passed so quiz was automatically submitted.<br />If you need to retry, contact your teacher to unlock/prolong exam time.',
  },
  skholeCertifiedExamInfo: {
    id: 'ViewQuiz.skholeCertifiedExamInfo',
    defaultMessage:
      'Please answer questions precisely and according to instructions.<br />\n' +
      'Note capital and small letters, punctuation marks, spaces etc.<br />\n' +
      'Exam is automatically reviewed and incorrect answers are marked as mistakes.<br />\n' +
      'Answers cannot be altered after exam is finished.',
  },
  pleaseEnterNameAndOrganization: {
    id: 'General.pleaseEnterNameAndOrganization',
    defaultMessage: 'Please enter name and organisation of supervisor',
  },
  supervisorName: {
    id: 'General.supervisorName',
    defaultMessage: 'Name',
  },
  supervisorOrganization: {
    id: 'General.supervisorOrganization',
    defaultMessage: 'Organization',
  },
  required: {
    id: 'General.Required',
    defaultMessage: 'Required',
  },
  beforePageLeaveMessage: {
    id: 'ViewQuiz.beforePageLeaveMessage',
    defaultMessage:
      'Are you sure you want to leave from exam without fully completing it?',
  },
  connectivityError: {
    id: 'General.connectivityError',
    defaultMessage:
      'Connection to service failed. Please check your internet connection.',
  },
  mathQuestionNotAllowedDecimalsHint: {
    id: 'ViewQuiz.mathQuestionNotAllowedDecimalsHint',
    defaultMessage: 'Decimals in the answer are not allowed',
  },
  mathQuestionAllowedDecimalsHint: {
    id: 'ViewQuiz.mathQuestionAllowedDecimalsHint',
    defaultMessage:
      'Required {allowedDecimals} {allowedDecimals, plural, one {sign} other {signs}} after the comma',
  },
  personalityConfirmationTitle: {
    id: 'ViewQuiz.personalityConfirmationTitle',
    defaultMessage: 'You are signed in as {firstName} {lastName}. Is it you?',
  },
  personalityConfirmationConfirmText: {
    id: 'ViewQuiz.personalityConfirmationConfirmText',
    defaultMessage: 'Yes, continue to the exam',
  },
  personalityConfirmationCancelTitle: {
    id: 'ViewQuiz.personalityConfirmationCancelTitle',
    defaultMessage: 'No, log out',
  },
});

export default messages;
